import React, { useState, useEffect, useMemo } from 'react';

import useBranchPathsStore, { getBranchPathsStore } from './useBranchPathsStore';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import { getCurrentTime } from '../../utils/getCurrentTime';
import { send_component_save_request, send_request } from '../../utils/Request';
import { injectMetadataFields } from '../../utils/buildComponentSavePayload';
import { IndividualComponentLoader } from '../../utils/ComponentLoadingSkeleton';

import { Grid, styled } from '@mui/material';
import CustomPaper from '../common/CustomPaper';

const Text = styled('span')(({ bold }) => ({
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: bold ? 700 : 400,
}));

const BranchPathsTemplate = (props) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(null);
  const [status, setStatus] = useState(null);

  const store = useMemo(() => getBranchPathsStore(props.component_id), [props.component_id]);

  const componentName = useProjectStore((s) => s.componentName);

  useEffect(() => {
    store.getState().setComponentName(componentName);
  }, [componentName]);

  useEffect(() => {
    if (!props.component_id) return;

    // If store was prefilled from canvas load, skip the REST fetch
    if (store.getState().loaded) {
      props.onComponentNameChanged(store.getState().name);
      props.onLastModifiedChanged(store.getState().lastModified);
      setLoading(false);
      props.setChildTemplateLoaded(true);
      return;
    }

    setLoading(true);

    const URL = `project-service/project/component/query/${props.component_id}/at-version/${props.version}`;

    send_request(URL, null, null)
      .then((response) => {
        if (response && response.data) {
          const { components } = response.data;

          if (components) {
            store.getState().setComponentData(components[0]);
            store.setState({ loaded: true });
            props.onComponentDescriptionChanged(components[0].description);
            props.onComponentNameChanged(store.getState().name);
            props.onLastModifiedChanged(store.getState().lastModified);
          }
        }

        setLoading(false);
        props.setChildTemplateLoaded(true);
      })
      .catch((err) => {
        throw Error(err.message);
      });
  }, []);

  if (!loading) {
    return (
      <CustomPaper
        elevation={2}
        sx={{
          p: 2,
          border: '1px solid #e9ecef',
          borderRadius: 2,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Text bold>Branch Paths</Text>
          </Grid>
          <Grid item xs={12}>
            <Text>
              This component is used in combination with the <Text bold>Conditional Path</Text>{' '}
              component to branch the workflow into multiple paths.
            </Text>
          </Grid>
          <Grid item xs={12}>
            <Text>
              This component can only be connected to <Text bold>Conditional Path</Text>{' '}
              components, and Conditional Workflow components can only have a Branch Paths
              component as its previous component or input.
            </Text>
          </Grid>
        </Grid>
      </CustomPaper>
    );
  } else return <IndividualComponentLoader />;
};

export default BranchPathsTemplate;
